export default __webpack_public_path__ + "static/media/censuringstrike2.9ad9e61c.png";